// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .chargingMainDiv_Bus .btn-primary{
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
}
.chargingMainDiv_Bus .btn-outline-primary{
  border-color: #83A4CF !important;
  color: #83A4CF !important;
}
.chargingMainDiv_Bus .ev_filter_icon {
  background: #fff !important;
  color: #83A4CF !important;
} */


/*********************** Slow Button *************************/
/* .kpiSlowBTN_Bus .btn-outline-primary{
  border-color:#83A4CF !important;
}
.kpiSlowBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
} */
/* .kpiSlowBTN_Bus .btn-outline-primary {
  --bs-btn-color: #83A4CF !important;
  --bs-btn-border-color: #83A4CF !important;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #83A4CF !important;
  --bs-btn-hover-border-color: #83A4CF !important;
  --bs-btn-focus-shadow-rgb: 13,110,253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #83A4CF !important;
  --bs-btn-active-border-color: #83A4CF !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #83A4CF !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #83A4CF !important;
  --bs-gradient: none;
}

.kpiSlowBTN_Bus .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
  }
  .kpiSlowBTN_Bus .ev_SButton {
    background: none !important;
    color: #7b7878 !important;
    border-color: #7b7878 !important;
  }

.kpiSlowBTN_Bus .btn-outline-primary:hover{
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
} */
/*********************** Slow Button Ends *************************/


/*********************** Fast Button *************************/
/* .kpiFastBTN_Bus .btn-outline-warning{

}
.kpiFastBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
} */
/* .kpiFastBTN_Bus .btn-outline-warning {
  --bs-btn-color: #3578b0 !important;
  --bs-btn-border-color: #3578b0 !important;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #3578b0 !important;
  --bs-btn-hover-border-color: #3578b0 !important;
  --bs-btn-focus-shadow-rgb: 255,193,7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3578b0 !important;
  --bs-btn-active-border-color: #3578b0 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3578b0 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3578b0 !important;
  --bs-gradient: none;
} */

/* .kpiFastBTN_Bus .ev_FButton {
  background: none !important;
  border-color: #7b7878;
} */


/*********************** Fast Button Ends *************************/

/* .bg-white{
	background-color:#fff;
} */

/* .chargingMainDiv_Bus{
  margin-top: 15px;
} */

/* .chargingWidget_Bus{
	box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
	border-radius: 5px;
  background: #CDDAEA;
} */
/* .chargingWidgetIcon_Bus img{
	width:50px;
	height:50px;
} */
.EnergyPageCustom_Orion_chargingWidgetIcon1_Orion__N9dfi img {
  width: 35px;
  height: 35px;
}

/* .chargingWidgetIcon_Bus-32_Bus img{
	width:32px;height:32px;
} */
.EnergyPageCustom_Orion_chargingTitleBg_Orion__xJm1S {
  font-size: 1em;
  color: #0E3157;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
}

.EnergyPageCustom_Orion_energyTitleChart_Orion__FWTmt {
  font-size: 0.9em;
  color: #0E3157;
  font-weight: 600;
  margin-bottom: 5px;
  text-align: left;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
}

.EnergyPageCustom_Orion_chargingChartbox_Orion__9ecGk {
  background: #FFFFFF;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
}

/* .wd_Bus{
	min-height: 330px !important;
} */
.EnergyPageCustom_Orion_wd_4_charts_Orion__Lvxx\\+ {
  min-height: 307px !important;
}

.EnergyPageCustom_Orion_highlightBoxKpi_Orion__z2pGA {}

/* .highlightTableSec_Bus{
	min-height: 310px !important;
} */
.EnergyPageCustom_Orion_chargingChartHGT_Orion__OLOF5 {
  padding: 10px;
}

.EnergyPageCustom_Orion_chargingH5_Orion__MLEoQ .EnergyPageCustom_Orion_h5__eE1UV {
  font-size: 1rem !important;
}

.EnergyPageCustom_Orion_chargingKpiSmallTxt_Orion__cOxDh {
  font-size: 77% !important;
  line-height: 1em !important;
}

.EnergyPageCustom_Orion_tableContent_Orion__F1WsG table tr td {
  font-size: 0.8em;
}

.EnergyPageCustom_Orion_chargingFilterForm_Orion__0tmSP>.EnergyPageCustom_Orion_form-label__4i3OF {
  font-size: 0.825em;
}

.EnergyPageCustom_Orion_chargingHeadfont_Orion__we\\+wk {
  font-size: 1.8rem;
}

.EnergyPageCustom_Orion_topRightDropMenu_Orion__I-Xqk .EnergyPageCustom_Orion_dropdown-menu__5H9Gh[data-bs-popper] {
  right: 0 !important;
  left: auto;
}

/********************  *********************/

/* .contentScroll_Bus{
} */

/* .chargingWidget_Bus p {
    line-height: 1rem !important;
}
.chargingWidget_Bus p small{
	font-size:80% !important;
} */

/***************************** Toggle Switch ***************************/
.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_form-switch__3z\\+MX .EnergyPageCustom_Orion_form-check-input__rPdT1:checked:before {
  content: "C";
  position: absolute;
  width: 20px;
  height: 10px;
  padding-left: 20px;
  margin-top: -1px;
  font-size: 0.7em;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_form-switch__3z\\+MX .EnergyPageCustom_Orion_form-check-input__rPdT1:before {
  content: "V";
  position: absolute;
  width: 20px;
  height: 10px;
  padding-left: 5px;
  margin-top: -1px;
  font-size: 0.7em;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_form-switch__3z\\+MX .EnergyPageCustom_Orion_form-check-input__rPdT1 {
  color: #83A4CF !important;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_toggle-button-cover__jt8\\+A {
  position: relative;
  top: 8px;
}

.EnergyPageCustom_Orion_dropdownSelectBtnEnergy_Orion__SeTQH {
  width: fit-content;
  margin-bottom: 2px;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_button-cover__W-eRQ {
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_button-cover__W-eRQ:before {
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_button-cover__W-eRQ,
.EnergyPageCustom_Orion_knobs__\\+hMCj,
.EnergyPageCustom_Orion_layer__Zgbx2 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_buttonbtn__t9xwZ {
  position: relative;
  top: 50%;
  width: 50px;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_buttonbtn__t9xwZ.EnergyPageCustom_Orion_r__C3hDN,
.EnergyPageCustom_Orion_buttonbtn__t9xwZ.EnergyPageCustom_Orion_r__C3hDN .EnergyPageCustom_Orion_layer__Zgbx2 {
  border-radius: 100px;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_button__2m6Vk.EnergyPageCustom_Orion_b2__hpCXC {
  border-radius: 2px;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_checkbox__vHkaI {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_knobs__\\+hMCj {
  z-index: 2;
}

.EnergyPageCustom_Orion_toggleBtn_Orion__D3qH\\+ .EnergyPageCustom_Orion_layer__Zgbx2 {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
}

/* Button 1 */
#EnergyPageCustom_Orion_button-1_Orion__fTZwl .EnergyPageCustom_Orion_knobs__\\+hMCj:before {
  content: "V";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 6px 4px;
  background-color: #83A4CF;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#EnergyPageCustom_Orion_button-1_Orion__fTZwl .EnergyPageCustom_Orion_checkbox__vHkaI:checked+.EnergyPageCustom_Orion_knobs__\\+hMCj:before {
  content: "C";
  left: 30px;
  background-color: #3578b0;
}

#EnergyPageCustom_Orion_button-1_Orion__fTZwl .EnergyPageCustom_Orion_checkbox__vHkaI:checked~.EnergyPageCustom_Orion_layer__Zgbx2 {
  background-color: #94c1e6;
}

#EnergyPageCustom_Orion_button-1_Orion__fTZwl .EnergyPageCustom_Orion_knobs__\\+hMCj,
#EnergyPageCustom_Orion_button-1_Orion__fTZwl .EnergyPageCustom_Orion_knobs__\\+hMCj:before,
#EnergyPageCustom_Orion_button-1_Orion__fTZwl .EnergyPageCustom_Orion_layer__Zgbx2 {
  transition: 0.3s ease all;
}

/***************************** PageTwo *******************************/

/*************************  *****************************/
/* .kpiNotificationSlow_Bus{
	color: #83A4CF;
    font-size: 0.7em;
    font-weight: 500;
} */
/* .kpiNotificationFast_Bus{
	color:#3578b0;
	font-size:0.7em;
	font-weight:500;
} */

/* .kpiNotificationBoth_Bus{
	color:#72D817;
	font-size:0.7em;
	font-weight:500;
} */
/* media queries start here */

/* @media (min-width: 1440px) {
.col205{
	flex: 0 0 auto;
    width: 20% !important;
}
} */

/* @media (max-width: 1440px) {
.highlightTableSec_Bus{
	min-height: 310px !important;
}
} */

/* @media (min-width: 1336px) {
.col205{
	flex: 0 0 auto;
    width: 20% !important;
}
} */


/* @media (max-width: 1024px) {
.highlightTableSec_Bus{
	min-height: 330px !important;
}
} */


/* @media (min-width: 992px) {
.col205{
	flex: 0 0 auto;
    width: 20% !important;
}
} */


/* @media (min-width: 836px) {
} */

@media screen and (max-width: 740px) {
  .EnergyPageCustom_Orion_chargingTitleBg_Orion__xJm1S {
    font-size: 0.9em;
  }
}


/* @media screen and (max-width: 720px) {
}

@media screen and (max-width: 480px) {
} */

@media screen and (max-width: 480px) {

  /* .chargingHeadfont_Bus {
    font-size: 1rem;
} */
  .EnergyPageCustom_Orion_chargingTitleBg_Orion__xJm1S {
    font-size: 0.9em;
  }
}

/* @media screen and (max-width: 320px) {

} */

.EnergyPageCustom_Orion_highlight_five_Orion__BDlbZ {
  margin: auto;
}

/* .text_bottom_Bus{
  margin-bottom: '-16px !important';
  display: none;
  z-index: 1;
} */
/* .btn-infotable_Bus:active {
  color: black;
  background-color: #fff;
  border-color: #32879c; 
} */

/* @media (min-width: 1440px) {
  .col-19 {
    flex: 0 0 calc(100% / 19);
  max-width: calc(100% / 19);
  }
}

@media (min-width: 1336px) {
  .col-19 {
    flex: 0 0 calc(100% / 19);
  max-width: calc(100% / 19);
  }
}

@media (min-width: 992px) {
  .col-19 {
    flex: 0 0 calc(100% / 19);
  max-width: calc(100% / 19);
  }
} */

.EnergyPageCustom_Orion_energyChartboxNew_Orion__OX9Or {
  background: #FFFFFF;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  height: auto;
  border-radius: 5px 5px 0 0;
}

.EnergyPageCustom_Orion_highBold__7YvUS {
  font-weight: bold;
  color: black;
  font-size: 16px !important
}

.EnergyPageCustom_Orion_filter_Orion_icon_f__TXJ5X .EnergyPageCustom_Orion_rca_btn__vJidz .EnergyPageCustom_Orion_rca_btn_Orion__Uw555 {
  background-color: #ffa650;
}

.EnergyPageCustom_Orion_filter_Orion_icon_f__TXJ5X .EnergyPageCustom_Orion_rca_btn__vJidz .EnergyPageCustom_Orion_rca_btn_Orion__Uw555:hover {
  background-color: #fcb877 !important;
  border-color: #fcb877 !important;
}

.EnergyPageCustom_Orion_popUpTable__0APt3 {
  background-color: rgb(131, 164, 207);
  color: rgb(255, 255, 255);
  position: sticky;
  top: 0;
  z-index: 0;
}

/* .custom-table .p-datatable-thead th {
  background-color: #83A4CF;
  color: white;
}

.custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {
  color: white;
  height: 20px!important;
  width: 12px!important;
} */

.EnergyPageCustom_Orion_main_hole_background__aYvhC {
  background-color: #F2F3FC;
  padding-bottom: 1px;
}

.EnergyPageCustom_Orion_nav-item__L-G7U .EnergyPageCustom_Orion_nav_in_line__1187n {
  padding: 8px;
}

/* .text_bold_gauge{
  font-weight: bold;
} */

/* .badge {
  color: white;
  padding: 2px 0px 6px 0px;
  text-align: center;
  border-radius: 5px;
  width: 135px;
  display: inline-block;
  text-transform: none;
} */

.EnergyPageCustom_Orion_badgefleet__xpDga {
  color: white;
  padding: 0px 0px 3px 0px;
  text-align: center;
  border-radius: 5px;
  width: 115px;
  display: inline-block;
  text-transform: none;
}

.EnergyPageCustom_Orion_badge-text__w4xje {
  font-size: 15px;
}

.EnergyPageCustom_Orion_badge-text-fleet__MBCbZ {
  font-size: 15px;
  font-weight: 600;
}

.EnergyPageCustom_Orion_btn__BJ0yd.EnergyPageCustom_Orion_btn_summary__-JnsN {
  color: white;
  background-color: #83A4CF !important;
}

.EnergyPageCustom_Orion_btn__BJ0yd.EnergyPageCustom_Orion_btn_summary__-JnsN:hover {
  color: white;
  background-color: #83A4CF !important;
}

.EnergyPageCustom_Orion_custom-plot__T6h\\+k .EnergyPageCustom_Orion_gtitle__-7BZb {
  background-color: lightblue;
}

/* .row_margin_top{
  margin-top: -10px!important;
} */

.EnergyPageCustom_Orion_to_stick__aTCiN {
  display: contents;
}

.EnergyPageCustom_Orion_histo_table_th__QQi2K {
  background-color: #83A4CF;
  color: #fff;
  position: sticky;
  top: 0;
  border-top: 1px solid gray;
}

.EnergyPageCustom_Orion_histo_table_tb__vlfG5 {
  border-left: 1px solid gray;
  border-right: 1px solid gray;
}



/*  Sidd FleetEV  */

.EnergyPageCustom_Orion_tablecolumn__KuVVx th,
.EnergyPageCustom_Orion_tablecolumn__KuVVx td {
  width: calc(100% / 5);
  /* Adjust the divisor based on the number of columns */
  max-width: calc(100% / 5);
  /* Adjust the divisor based on the number of columns */
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/Energyanalysis_Orion/EnergyPageCustom_Orion.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;GAWG;;;AAGH,8DAA8D;AAC9D;;;;;GAKG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;AACH,mEAAmE;;;AAGnE,8DAA8D;AAC9D;;;;;GAKG;AACH;;;;;;;;;;;;;;;GAeG;;AAEH;;;GAGG;;;AAGH,mEAAmE;;AAEnE;;GAEG;;AAEH;;GAEG;;AAEH;;;;GAIG;AACH;;;GAGG;AACH;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;GAEG;AACH;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;GAEG;AACH;EACE,4BAA4B;AAC9B;;AAEA,sDAAwB;;AAExB;;GAEG;AACH;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,4CAA4C;;AAE5C;GACG;;AAEH;;;;;GAKG;;AAEH,wEAAwE;AACxE;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,sEAAsE;;AAEtE,yDAAyD;AACzD;;;;GAIG;AACH;;;;GAIG;;AAEH;;;;GAIG;AACH,6BAA6B;;AAE7B;;;;;GAKG;;AAEH;;;;GAIG;;AAEH;;;;;GAKG;;;AAGH;;;;GAIG;;;AAGH;;;;;GAKG;;;AAGH;GACG;;AAEH;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;;;;GAIG;;AAEH;;EAEE;;GAEC;EACD;IACE,gBAAgB;EAClB;AACF;;AAEA;;GAEG;;AAEH;EACE,YAAY;AACd;;AAEA;;;;GAIG;AACH;;;;GAIG;;AAEH;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH;EACE,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;;;;;;;;GASG;;AAEH;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;GAEG;;AAEH;;;;;;;;GAQG;;AAEH;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;;;AAIA,mBAAmB;;AAEnB;;EAEE,qBAAqB;EACrB,sDAAsD;EACtD,yBAAyB;EACzB,sDAAsD;EACtD;;wBAEsB;AACxB","sourcesContent":["/* .chargingMainDiv_Bus .btn-primary{\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n}\n.chargingMainDiv_Bus .btn-outline-primary{\n  border-color: #83A4CF !important;\n  color: #83A4CF !important;\n}\n.chargingMainDiv_Bus .ev_filter_icon {\n  background: #fff !important;\n  color: #83A4CF !important;\n} */\n\n\n/*********************** Slow Button *************************/\n/* .kpiSlowBTN_Bus .btn-outline-primary{\n  border-color:#83A4CF !important;\n}\n.kpiSlowBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n} */\n/* .kpiSlowBTN_Bus .btn-outline-primary {\n  --bs-btn-color: #83A4CF !important;\n  --bs-btn-border-color: #83A4CF !important;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #83A4CF !important;\n  --bs-btn-hover-border-color: #83A4CF !important;\n  --bs-btn-focus-shadow-rgb: 13,110,253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #83A4CF !important;\n  --bs-btn-active-border-color: #83A4CF !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #83A4CF !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #83A4CF !important;\n  --bs-gradient: none;\n}\n\n.kpiSlowBTN_Bus .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n  }\n  .kpiSlowBTN_Bus .ev_SButton {\n    background: none !important;\n    color: #7b7878 !important;\n    border-color: #7b7878 !important;\n  }\n\n.kpiSlowBTN_Bus .btn-outline-primary:hover{\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n} */\n/*********************** Slow Button Ends *************************/\n\n\n/*********************** Fast Button *************************/\n/* .kpiFastBTN_Bus .btn-outline-warning{\n\n}\n.kpiFastBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n} */\n/* .kpiFastBTN_Bus .btn-outline-warning {\n  --bs-btn-color: #3578b0 !important;\n  --bs-btn-border-color: #3578b0 !important;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #3578b0 !important;\n  --bs-btn-hover-border-color: #3578b0 !important;\n  --bs-btn-focus-shadow-rgb: 255,193,7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #3578b0 !important;\n  --bs-btn-active-border-color: #3578b0 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #3578b0 !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #3578b0 !important;\n  --bs-gradient: none;\n} */\n\n/* .kpiFastBTN_Bus .ev_FButton {\n  background: none !important;\n  border-color: #7b7878;\n} */\n\n\n/*********************** Fast Button Ends *************************/\n\n/* .bg-white{\n\tbackground-color:#fff;\n} */\n\n/* .chargingMainDiv_Bus{\n  margin-top: 15px;\n} */\n\n/* .chargingWidget_Bus{\n\tbox-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n\tborder-radius: 5px;\n  background: #CDDAEA;\n} */\n/* .chargingWidgetIcon_Bus img{\n\twidth:50px;\n\theight:50px;\n} */\n.chargingWidgetIcon1_Orion img {\n  width: 35px;\n  height: 35px;\n}\n\n/* .chargingWidgetIcon_Bus-32_Bus img{\n\twidth:32px;height:32px;\n} */\n.chargingTitleBg_Orion {\n  font-size: 1em;\n  color: #0E3157;\n  font-weight: 600;\n  margin-bottom: 10px;\n  text-align: center;\n  background: #E0E0E0;\n  border-radius: 5px 5px 0 0;\n}\n\n.energyTitleChart_Orion {\n  font-size: 0.9em;\n  color: #0E3157;\n  font-weight: 600;\n  margin-bottom: 5px;\n  text-align: left;\n  background: #E0E0E0;\n  border-radius: 5px 5px 0 0;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n}\n\n.chargingChartbox_Orion {\n  background: #FFFFFF;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n}\n\n/* .wd_Bus{\n\tmin-height: 330px !important;\n} */\n.wd_4_charts_Orion {\n  min-height: 307px !important;\n}\n\n.highlightBoxKpi_Orion {}\n\n/* .highlightTableSec_Bus{\n\tmin-height: 310px !important;\n} */\n.chargingChartHGT_Orion {\n  padding: 10px;\n}\n\n.chargingH5_Orion .h5 {\n  font-size: 1rem !important;\n}\n\n.chargingKpiSmallTxt_Orion {\n  font-size: 77% !important;\n  line-height: 1em !important;\n}\n\n.tableContent_Orion table tr td {\n  font-size: 0.8em;\n}\n\n.chargingFilterForm_Orion>.form-label {\n  font-size: 0.825em;\n}\n\n.chargingHeadfont_Orion {\n  font-size: 1.8rem;\n}\n\n.topRightDropMenu_Orion .dropdown-menu[data-bs-popper] {\n  right: 0 !important;\n  left: auto;\n}\n\n/********************  *********************/\n\n/* .contentScroll_Bus{\n} */\n\n/* .chargingWidget_Bus p {\n    line-height: 1rem !important;\n}\n.chargingWidget_Bus p small{\n\tfont-size:80% !important;\n} */\n\n/***************************** Toggle Switch ***************************/\n.toggleBtn_Orion .form-switch .form-check-input:checked:before {\n  content: \"C\";\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  padding-left: 20px;\n  margin-top: -1px;\n  font-size: 0.7em;\n}\n\n.toggleBtn_Orion .form-switch .form-check-input:before {\n  content: \"V\";\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  padding-left: 5px;\n  margin-top: -1px;\n  font-size: 0.7em;\n}\n\n.toggleBtn_Orion .form-switch .form-check-input {\n  color: #83A4CF !important;\n}\n\n.toggleBtn_Orion .toggle-button-cover {\n  position: relative;\n  top: 8px;\n}\n\n.dropdownSelectBtnEnergy_Orion {\n  width: fit-content;\n  margin-bottom: 2px;\n}\n\n.toggleBtn_Orion .button-cover {\n  background-color: #fff;\n  box-shadow: 0 10px 20px -8px #c5d6d6;\n  border-radius: 4px;\n}\n\n.toggleBtn_Orion .button-cover:before {\n  color: #d7e3e3;\n  font-size: 12px;\n  line-height: 1;\n  padding: 5px;\n}\n\n.toggleBtn_Orion .button-cover,\n.knobs,\n.layer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.toggleBtn_Orion .buttonbtn {\n  position: relative;\n  top: 50%;\n  width: 50px;\n}\n\n.toggleBtn_Orion .buttonbtn.r,\n.buttonbtn.r .layer {\n  border-radius: 100px;\n}\n\n.toggleBtn_Orion .button.b2 {\n  border-radius: 2px;\n}\n\n.toggleBtn_Orion .checkbox {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.toggleBtn_Orion .knobs {\n  z-index: 2;\n}\n\n.toggleBtn_Orion .layer {\n  width: 100%;\n  background-color: #ebf7fc;\n  transition: 0.3s ease all;\n  z-index: 1;\n}\n\n/* Button 1 */\n#button-1_Orion .knobs:before {\n  content: \"V\";\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 1;\n  padding: 6px 4px;\n  background-color: #83A4CF;\n  border-radius: 50%;\n  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\n}\n\n#button-1_Orion .checkbox:checked+.knobs:before {\n  content: \"C\";\n  left: 30px;\n  background-color: #3578b0;\n}\n\n#button-1_Orion .checkbox:checked~.layer {\n  background-color: #94c1e6;\n}\n\n#button-1_Orion .knobs,\n#button-1_Orion .knobs:before,\n#button-1_Orion .layer {\n  transition: 0.3s ease all;\n}\n\n/***************************** PageTwo *******************************/\n\n/*************************  *****************************/\n/* .kpiNotificationSlow_Bus{\n\tcolor: #83A4CF;\n    font-size: 0.7em;\n    font-weight: 500;\n} */\n/* .kpiNotificationFast_Bus{\n\tcolor:#3578b0;\n\tfont-size:0.7em;\n\tfont-weight:500;\n} */\n\n/* .kpiNotificationBoth_Bus{\n\tcolor:#72D817;\n\tfont-size:0.7em;\n\tfont-weight:500;\n} */\n/* media queries start here */\n\n/* @media (min-width: 1440px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n} */\n\n/* @media (max-width: 1440px) {\n.highlightTableSec_Bus{\n\tmin-height: 310px !important;\n}\n} */\n\n/* @media (min-width: 1336px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n} */\n\n\n/* @media (max-width: 1024px) {\n.highlightTableSec_Bus{\n\tmin-height: 330px !important;\n}\n} */\n\n\n/* @media (min-width: 992px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n} */\n\n\n/* @media (min-width: 836px) {\n} */\n\n@media screen and (max-width: 740px) {\n  .chargingTitleBg_Orion {\n    font-size: 0.9em;\n  }\n}\n\n\n/* @media screen and (max-width: 720px) {\n}\n\n@media screen and (max-width: 480px) {\n} */\n\n@media screen and (max-width: 480px) {\n\n  /* .chargingHeadfont_Bus {\n    font-size: 1rem;\n} */\n  .chargingTitleBg_Orion {\n    font-size: 0.9em;\n  }\n}\n\n/* @media screen and (max-width: 320px) {\n\n} */\n\n.highlight_five_Orion {\n  margin: auto;\n}\n\n/* .text_bottom_Bus{\n  margin-bottom: '-16px !important';\n  display: none;\n  z-index: 1;\n} */\n/* .btn-infotable_Bus:active {\n  color: black;\n  background-color: #fff;\n  border-color: #32879c; \n} */\n\n/* @media (min-width: 1440px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n@media (min-width: 1336px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n@media (min-width: 992px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n} */\n\n.energyChartboxNew_Orion {\n  background: #FFFFFF;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  height: auto;\n  border-radius: 5px 5px 0 0;\n}\n\n.highBold {\n  font-weight: bold;\n  color: black;\n  font-size: 16px !important\n}\n\n.filter_Orion_icon_f .rca_btn .rca_btn_Orion {\n  background-color: #ffa650;\n}\n\n.filter_Orion_icon_f .rca_btn .rca_btn_Orion:hover {\n  background-color: #fcb877 !important;\n  border-color: #fcb877 !important;\n}\n\n.popUpTable {\n  background-color: rgb(131, 164, 207);\n  color: rgb(255, 255, 255);\n  position: sticky;\n  top: 0;\n  z-index: 0;\n}\n\n/* .custom-table .p-datatable-thead th {\n  background-color: #83A4CF;\n  color: white;\n}\n\n.custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {\n  color: white;\n  height: 20px!important;\n  width: 12px!important;\n} */\n\n.main_hole_background {\n  background-color: #F2F3FC;\n  padding-bottom: 1px;\n}\n\n.nav-item .nav_in_line {\n  padding: 8px;\n}\n\n/* .text_bold_gauge{\n  font-weight: bold;\n} */\n\n/* .badge {\n  color: white;\n  padding: 2px 0px 6px 0px;\n  text-align: center;\n  border-radius: 5px;\n  width: 135px;\n  display: inline-block;\n  text-transform: none;\n} */\n\n.badgefleet {\n  color: white;\n  padding: 0px 0px 3px 0px;\n  text-align: center;\n  border-radius: 5px;\n  width: 115px;\n  display: inline-block;\n  text-transform: none;\n}\n\n.badge-text {\n  font-size: 15px;\n}\n\n.badge-text-fleet {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.btn.btn_summary {\n  color: white;\n  background-color: #83A4CF !important;\n}\n\n.btn.btn_summary:hover {\n  color: white;\n  background-color: #83A4CF !important;\n}\n\n.custom-plot .gtitle {\n  background-color: lightblue;\n}\n\n/* .row_margin_top{\n  margin-top: -10px!important;\n} */\n\n.to_stick {\n  display: contents;\n}\n\n.histo_table_th {\n  background-color: #83A4CF;\n  color: #fff;\n  position: sticky;\n  top: 0;\n  border-top: 1px solid gray;\n}\n\n.histo_table_tb {\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n}\n\n\n\n/*  Sidd FleetEV  */\n\n.tablecolumn th,\n.tablecolumn td {\n  width: calc(100% / 5);\n  /* Adjust the divisor based on the number of columns */\n  max-width: calc(100% / 5);\n  /* Adjust the divisor based on the number of columns */\n  /* overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chargingWidgetIcon1_Orion": `EnergyPageCustom_Orion_chargingWidgetIcon1_Orion__N9dfi`,
	"chargingTitleBg_Orion": `EnergyPageCustom_Orion_chargingTitleBg_Orion__xJm1S`,
	"energyTitleChart_Orion": `EnergyPageCustom_Orion_energyTitleChart_Orion__FWTmt`,
	"chargingChartbox_Orion": `EnergyPageCustom_Orion_chargingChartbox_Orion__9ecGk`,
	"wd_4_charts_Orion": `EnergyPageCustom_Orion_wd_4_charts_Orion__Lvxx+`,
	"highlightBoxKpi_Orion": `EnergyPageCustom_Orion_highlightBoxKpi_Orion__z2pGA`,
	"chargingChartHGT_Orion": `EnergyPageCustom_Orion_chargingChartHGT_Orion__OLOF5`,
	"chargingH5_Orion": `EnergyPageCustom_Orion_chargingH5_Orion__MLEoQ`,
	"h5": `EnergyPageCustom_Orion_h5__eE1UV`,
	"chargingKpiSmallTxt_Orion": `EnergyPageCustom_Orion_chargingKpiSmallTxt_Orion__cOxDh`,
	"tableContent_Orion": `EnergyPageCustom_Orion_tableContent_Orion__F1WsG`,
	"chargingFilterForm_Orion": `EnergyPageCustom_Orion_chargingFilterForm_Orion__0tmSP`,
	"form-label": `EnergyPageCustom_Orion_form-label__4i3OF`,
	"chargingHeadfont_Orion": `EnergyPageCustom_Orion_chargingHeadfont_Orion__we+wk`,
	"topRightDropMenu_Orion": `EnergyPageCustom_Orion_topRightDropMenu_Orion__I-Xqk`,
	"dropdown-menu": `EnergyPageCustom_Orion_dropdown-menu__5H9Gh`,
	"toggleBtn_Orion": `EnergyPageCustom_Orion_toggleBtn_Orion__D3qH+`,
	"form-switch": `EnergyPageCustom_Orion_form-switch__3z+MX`,
	"form-check-input": `EnergyPageCustom_Orion_form-check-input__rPdT1`,
	"toggle-button-cover": `EnergyPageCustom_Orion_toggle-button-cover__jt8+A`,
	"dropdownSelectBtnEnergy_Orion": `EnergyPageCustom_Orion_dropdownSelectBtnEnergy_Orion__SeTQH`,
	"button-cover": `EnergyPageCustom_Orion_button-cover__W-eRQ`,
	"knobs": `EnergyPageCustom_Orion_knobs__+hMCj`,
	"layer": `EnergyPageCustom_Orion_layer__Zgbx2`,
	"buttonbtn": `EnergyPageCustom_Orion_buttonbtn__t9xwZ`,
	"r": `EnergyPageCustom_Orion_r__C3hDN`,
	"button": `EnergyPageCustom_Orion_button__2m6Vk`,
	"b2": `EnergyPageCustom_Orion_b2__hpCXC`,
	"checkbox": `EnergyPageCustom_Orion_checkbox__vHkaI`,
	"button-1_Orion": `EnergyPageCustom_Orion_button-1_Orion__fTZwl`,
	"highlight_five_Orion": `EnergyPageCustom_Orion_highlight_five_Orion__BDlbZ`,
	"energyChartboxNew_Orion": `EnergyPageCustom_Orion_energyChartboxNew_Orion__OX9Or`,
	"highBold": `EnergyPageCustom_Orion_highBold__7YvUS`,
	"filter_Orion_icon_f": `EnergyPageCustom_Orion_filter_Orion_icon_f__TXJ5X`,
	"rca_btn": `EnergyPageCustom_Orion_rca_btn__vJidz`,
	"rca_btn_Orion": `EnergyPageCustom_Orion_rca_btn_Orion__Uw555`,
	"popUpTable": `EnergyPageCustom_Orion_popUpTable__0APt3`,
	"main_hole_background": `EnergyPageCustom_Orion_main_hole_background__aYvhC`,
	"nav-item": `EnergyPageCustom_Orion_nav-item__L-G7U`,
	"nav_in_line": `EnergyPageCustom_Orion_nav_in_line__1187n`,
	"badgefleet": `EnergyPageCustom_Orion_badgefleet__xpDga`,
	"badge-text": `EnergyPageCustom_Orion_badge-text__w4xje`,
	"badge-text-fleet": `EnergyPageCustom_Orion_badge-text-fleet__MBCbZ`,
	"btn": `EnergyPageCustom_Orion_btn__BJ0yd`,
	"btn_summary": `EnergyPageCustom_Orion_btn_summary__-JnsN`,
	"custom-plot": `EnergyPageCustom_Orion_custom-plot__T6h+k`,
	"gtitle": `EnergyPageCustom_Orion_gtitle__-7BZb`,
	"to_stick": `EnergyPageCustom_Orion_to_stick__aTCiN`,
	"histo_table_th": `EnergyPageCustom_Orion_histo_table_th__QQi2K`,
	"histo_table_tb": `EnergyPageCustom_Orion_histo_table_tb__vlfG5`,
	"tablecolumn": `EnergyPageCustom_Orion_tablecolumn__KuVVx`
};
export default ___CSS_LOADER_EXPORT___;
